module.exports = __webpack_public_path__ + "img/company13.3bbd4d5f.png";